import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, Injectable} from '@angular/core';
import { AssignUser, guid } from './assign-user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { MessageService } from 'primeng/api';

@Injectable()
export class AssignUserRoleService  {

  constructor(private _httpClient: HttpClient,
    private _toastService : MessageService
    ) {
  }


  postUserStatus(user:any)
  {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
        userId : user.userId,
        status : user.isActive ? '1' : '0',
        loggedInUser : JSON.parse(localStorage.getItem("currentUser")).user.id
    };
      this._httpClient
        .post(`${environment.apiUrl}/user/update-user-status`, body, { headers : headers }).subscribe(res => {
          this._toastService.add({ severity: 'success', summary: "User status is updated successfully.", detail: '' });
        },
          error => {
            this._toastService.add({ severity: 'error', summary: error, detail: 'Error occured while updating user status.' });
          });
  }

  postUserRole(user:any)
  {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
        userId : user.userId,
        roleId : user.roleId,
        loggedInUser : JSON.parse(localStorage.getItem("currentUser")).user.id
    };
      this._httpClient
        .post(`${environment.apiUrl}/user/update-user-role`, body, { headers : headers }).subscribe(res => {
          this._toastService.add({ severity: 'success', summary: "User role is updated successfully.", detail: '' });
        },
          error => {
            this._toastService.add({ severity: 'error', summary: error, detail: 'Error occured while updating user role.' });
          });
  }
}